import React, { useState, useEffect, useMemo, useRef } from 'react';
import CommonComponent from "../../CommonComponent";
import NormalTable from '../../../../utility/table/NormalTable.jsx';
import { useTranslation } from 'react-i18next';
import usePersistentDateRange from '../../Common/usePersistentDateRange';
import useRegionalLevelSales from './useRegionalLevelSales';
import RegionalUnitsChart from './ChartLayout/RegionalUnitsChart';
import CoastDistributionChart from './ChartLayout/CoastDistributionChart';
import NoDataFound from '../NoDataFound/NoDataFound';
import Spinner from '../NoDataFound/Spinner';
import DashboardReady from '../DashboardReady/DashboardReady'
import categorySelectionDynamic from '../../Common/categorySelectionDynamic';
import ViewTypeSelect from "../ViewTypeSelect";
import { useOption } from '../../../../context/OptionContext.js';
import PremiumOverlayCard from "../../../../common/PremiumOverlayCard";
import { usePermissions } from "../../../../context/PermissionContext";
import PermissionControlledCard from '../../../../common/PermissionControlledCard.jsx';
import Tabs from '../TableTab/TableTab';
import AllowedCard from '../../../../common/AllowedCard.jsx';
import { addColumn } from '../../Common/addColumn.js';
const levels = ['region', 'state', 'city', 'postal'];
const levelData = ['state_section', 'city_section', 'pincode_section'];


const RegionalLevelSales = () => {
  const {
    coastDistributionState,
    unitsConsumptionState,
    getUnitsConsumption,
    getCoastDistribution,
    getRegionalLevelSales,
    regionalLevelSalesState, regionalLevelSalesSequence, regionalLevelSalesLoaded,
    loadingState,
    canShowTable, combinedPermission, combinedTablePermission, tablePermission, level, setLevel, accessDenied

  } = useRegionalLevelSales();
  const permission = usePermissions();
  const { selectedOption } = useOption();
  const [viewType, setViewType] = useState(() => {
  const savedView = localStorage.getItem("viewType");
  return savedView || "";
});

  // const [viewType, setViewType] = useState(() => {
  //   if (
  //     permission?.data?.area_wise_insights?.view_format?.category_wise?.display &&
  //     permission?.data?.area_wise_insights?.view_format?.category_wise?.allowed
  //   ) {
  //     // localStorage.setItem("viewType", "category");
  //     return localStorage.getItem("viewType");
  //   }
  //   if (
  //     permission?.data?.area_wise_insights?.view_format?.product_wise?.display &&
  //     permission?.data?.area_wise_insights?.view_format?.product_wise?.allowed
  //   ) {
  //     // localStorage.setItem("viewType", "product");
  //     return localStorage.getItem("viewType");
  //   }
  //   return localStorage.getItem("viewType");
  // });

  // useEffect(() => {
  //   const viewFormat = permission?.data?.area_wise_insights?.view_format;
  //   if (!viewFormat) return;

  //   const savedView = localStorage.getItem("viewType");
  //   const isProductAllowed = viewFormat?.product_wise?.allowed;
  //   const isCategoryAllowed = viewFormat?.category_wise?.allowed;

  //   let newView = savedView;

  //   //  Switch only if current view is not allowed
  //   if (savedView === "category" && !isCategoryAllowed && isProductAllowed) {
  //     newView = "product";
  //   }
  //   else if (savedView === "product" && !isProductAllowed && isCategoryAllowed) {
  //     newView = "category";
  //   }

  //   if (newView !== savedView) {
  //     setViewType(newView);
  //     localStorage.setItem("viewType", newView);
  //   }
  // }, [
  //   permission?.data?.area_wise_insights?.view_format?.product_wise?.allowed,
  //   permission?.data?.area_wise_insights?.view_format?.category_wise?.allowed
  // ]);


  useEffect(() => {
  const viewFormat = permission?.data?.area_wise_insights?.view_format;
  if (!viewFormat) return;

  const savedView = localStorage.getItem("viewType");

  const isProductAllowed = viewFormat?.product_wise?.allowed;
  const isCategoryAllowed = viewFormat?.category_wise?.allowed;

  let newView = savedView;

  // If nothing saved, pick the first allowed view
  if (!savedView) {
    if (isCategoryAllowed) newView = "category";
    else if (isProductAllowed) newView = "product";
  }

  // Switch only if the saved view is no longer allowed
  if (savedView === "category" && !isCategoryAllowed && isProductAllowed) {
    newView = "product";
  } else if (savedView === "product" && !isProductAllowed && isCategoryAllowed) {
    newView = "category";
  }

  if (newView && newView !== viewType) {
    setViewType(newView);
    localStorage.setItem("viewType", newView);
  }
}, [
  permission?.data?.area_wise_insights?.view_format?.product_wise?.allowed,
  permission?.data?.area_wise_insights?.view_format?.category_wise?.allowed
]);


  const handleViewTypeChange = (e) => {
  const value = e.target.value;
  setViewType(value);
  localStorage.setItem("viewType", value);
  };
  const { t } = useTranslation();
  const {
    selectedRange,
    handleDateChange,
    formattedStart,
    formattedEnd,
  } = usePersistentDateRange();

  const [selectedIds, setSelectedIds] = useState({
    productId: [],
    categoryId: [],
    parentProductId: []
  });
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const downloadBtnPermission = permission?.data?.area_wise_insights?.table_section?.download_option?.display && permission?.data?.area_wise_insights?.table_section?.download_option?.allowed
  const prevLevelRef = useRef(level);

  useEffect(() => {
    prevLevelRef.current = level;
  }, [level]);

  const isLevelChanged = prevLevelRef.current !== level;

  const handlerFns = useMemo(() => [
    getUnitsConsumption,
    getCoastDistribution,
    getRegionalLevelSales
  ], [getUnitsConsumption, getCoastDistribution, getRegionalLevelSales]);

  const {
    categoryId,
    categoryName,
    handleCategoryClick,
    onBreadcrumbClick, handleParentProductClick
  } = categorySelectionDynamic(handlerFns, formattedStart, formattedEnd, selectedIds, level);
  const shouldFetchData =
   isLevelChanged ||(
    !isButtonDisabled &&
    (
      localStorage.getItem("viewType") === 'product' ? (selectedIds.productId.length === 0) : (selectedIds.categoryId.length === 0 && categoryId === null)

   ));
  useEffect(() => {
    if (shouldFetchData) {
      getUnitsConsumption({ formattedEnd, formattedStart, level, selectedIds });
    }
  }, [formattedStart, formattedEnd, level, isButtonDisabled]);

  useEffect(() => {
    if (shouldFetchData && level === "region") {
      getCoastDistribution({ formattedEnd, formattedStart, level, selectedIds });
    }
  }, [formattedStart, formattedEnd, level, isButtonDisabled]);

  // useEffect(() => {
  //   if((!isButtonDisabled && selectedIds.categoryId.length === 0 && categoryId === null) || !isButtonDisabled && selectedIds.productId.length === 0 && productId === null){
  //   getUnitsConsumption({ formattedEnd, formattedStart, level, selectedIds });
  //    }
  // }, [formattedStart, formattedEnd, level,isButtonDisabled]);


  // useEffect(() => {
  //   if((!isButtonDisabled && selectedIds.categoryId.length === 0 && categoryId === null) || !isButtonDisabled && selectedIds.productId.length === 0 && productId === null){
  //     getCoastDistribution({ formattedEnd, formattedStart, level, selectedIds });
  //   }
  // }, [formattedStart, formattedEnd, level,isButtonDisabled]);

  const handleColumnChange = async(selectedCols, allColumns) =>{
   const formattedColumns = allColumns
      .filter(col => col !== "id")
      .map(col => ({
        key: col,
        visible: selectedCols.includes(col)
      }));

    await addColumn({
      data: {
        section_name: "regional_sales",
        columns: formattedColumns
      }
    });
  getRegionalLevelSales({ formattedEnd, formattedStart, level });
  }

  useEffect(() => {
    getRegionalLevelSales({ formattedEnd, formattedStart, level });
  }, [formattedStart, formattedEnd, viewType, selectedOption?.id, level]);

  useEffect(() => {
    setIsButtonDisabled(false);
}, [selectedIds]);


// useEffect(() => {
//   // Enable button when user selects again
//   if (
//     selectedIds?.parentProductId?.length > 0 ||
//     selectedIds?.productId?.length > 0 ||
//     selectedIds?.categoryId?.length > 0
//   ) {
//     setIsButtonDisabled(false);
//   }

//   // Clear productId if parent product is selected
//   if (
//     selectedIds?.parentProductId?.length > 0 &&
//     selectedIds?.productId?.length > 0
//   ) {
//     setSelectedIds((prev) => ({
//       ...prev,
//       productId: [],
//     }));
//   }
// }, [
//   selectedIds?.parentProductId?.length,
//   selectedIds?.productId?.length,
//   selectedIds?.categoryId?.length,
// ]);

  const handleSelectionChange = (ids) => {
    const hasNoSelection =
      ids.productId.length === 0 && ids.categoryId.length === 0;

    if ((selectedIds.productId.length + selectedIds.categoryId.length > 0) && hasNoSelection) {
      window.location.reload();
    }

    setSelectedIds(ids);
  };

  const handleReflectSelection = (e) => {
    e.preventDefault();
    setIsButtonDisabled(true);
    getUnitsConsumption({ formattedEnd, formattedStart, level, selectedIds: selectedIds });
    getCoastDistribution({ formattedEnd, formattedStart, level, selectedIds: selectedIds });
  };


  const regionalLevelSalesStateEmpty =
    !regionalLevelSalesState || Object.keys(regionalLevelSalesState).length === 0;

  const levelLabel = {
    region: t("regionalLevelSales.regionWiseSales") || "Regional Wise Sales",
    state: t("regionalLevelSales.stateWiseSales") || "State Wise Sales",
    city: t("regionalLevelSales.cityWiseSales") || "City Wise Sales",
    postal: t("regionalLevelSales.pincodeWiseSales") || "Pincode Wise Sales"
  };

  const showCharts = levels.includes(level);
  const dashboardReady = localStorage.getItem('dashboard-ready') === 'true';
  const isPieChartVisible = !['city', 'postal', 'state'].includes(level);
  const chartColClass = isPieChartVisible ? 'col-12 col-md-8' : 'col-12';
  if (accessDenied) {
    return (
      <div className='d-flex justify-content-center' style={{ textAlign: "center", padding: "30px", fontWeight: "500" }}>
        <AllowedCard />
      </div>
    )
  }
  return (
    <>
      <CommonComponent
        key={level}
        defaultRange={selectedRange}
        onRangeChange={handleDateChange}
        categoryName={categoryName}
        categoryId={categoryId}
        onBreadcrumbClick={onBreadcrumbClick}
        viewType={viewType}
      />
      {!dashboardReady ? <DashboardReady /> :
        <section className="section dashboard area-wise-insights py-2">

          <div className="row mx-0">
            <div className="col-lg-12 p-0">
              <div className="container-fluid px-0">
                {showCharts && (
                  <div className='row flex-wrap graph-section mx-0'>
                    <div className="mb-3 p-0">
                      <ul className="nav nav-tabs custom-nav-tabs">
                        {levels.map((val) => {
                          let permissionKey = null;
                          if (val === "state") permissionKey = "state_section";
                          else if (val === "city") permissionKey = "city_section";
                          else if (val === "postal") permissionKey = "pincode_section";

                          const button = (

                            <li className="nav-item" key={val}>
                              <button
                                className={`nav-link ${level === val ? "active" : ""}`}
                                onClick={() => setLevel(val)}
                              >
                                {t(`regionalLevelSales.${val}`) || val}
                              </button>
                            </li>
                          );

                          return permissionKey ? (
                            <PermissionControlledCard
                              key={val}
                              permission={permission?.data?.area_wise_insights?.[permissionKey]?.table_view}
                              colClass=""
                            >
                              {button}
                            </PermissionControlledCard>
                          ) : (
                            button
                          );
                        })}
                      </ul>

                    </div>
                    {/* Regional Bar Chart */}
                    {/* <div className={chartColClass}> */}
                    <PermissionControlledCard permission={permission?.data?.area_wise_insights?.region_section?.bar_graph} colClass={`${level === "region" ? "col-12 col-md-8 col-lg-8 mb-3 p-0" : "col-12 p-0"}`}>
                      <div className="card total-revenue">
                        <div className="card-body h-auto card-height">
                          <div className="d-flex justify-content-between align-items-baseline">
                             <h5 className="kpi-heading">{t("regionalLevelSales.regionWiseSalesGraph")}</h5>
                          </div>
                          {loadingState?.unitsConsumptionState ? (
                            <Spinner height={300} />
                          ) : (
                            <RegionalUnitsChart downloadBtnPermission={downloadBtnPermission} chartData={unitsConsumptionState} level={level} filterData={{ formattedStart, formattedEnd, level, selectedIds }} />
                          )}
                        </div>
                      </div>
                    </PermissionControlledCard>
                    {/* </div> */}

                    {/* Pie Chart (hide if level is city or pincode) */}
                    <PermissionControlledCard permission={permission?.data?.area_wise_insights?.region_section?.distribution_pie_graph} colClass='col-12 col-md-4 col-lg-4 ps-md-3'>
                      {isPieChartVisible && (
                        <div className="col-12 col-md-12">
                          <div className="card total-revenue">
                            <div className="card-body h-auto d-flex flex-column card-height">
                              <h5 className="kpi-heading">{t("regionalLevelSales.costDistribution")}</h5>
                              <div className="flex-grow-1 d-flex align-items-center justify-content-center">
                                {loadingState?.coastDistributionState ? (
                                  <Spinner type="pie" height={300} />
                                ) : (
                                  <CoastDistributionChart chartData={coastDistributionState} />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </PermissionControlledCard>
                  </div>
                )}

                {/* Data Table */}
                <div className="col-12 px-0 mt-2 mx-md-0">
                  <div className="card">
                    <div className="card-body h-auto">
                      <div className="justify-content-between align-items-baseline">
                        <div className="d-flex justify-content-between align-items-baseline">
                          <h5 className="kpi-heading">{levelLabel[level]}</h5>
                          <PermissionControlledCard permission={combinedPermission} colClass="col-0">
                            <ViewTypeSelect value={viewType} onChange={handleViewTypeChange} permissions={permission?.data?.area_wise_insights?.view_format} />
                          </PermissionControlledCard>
                        </div>
                        {
                          regionalLevelSalesLoaded && Array.isArray(regionalLevelSalesState) && regionalLevelSalesState.length === 0 ? (
                            <div className='d-flex justify-content-center' style={{ textAlign: "center", padding: "30px", fontWeight: "500" }}>
                              No data found for the given criteria.
                            </div>
                          ) : (
                            (canShowTable) && (

                              <PermissionControlledCard permission={tablePermission} colClass=''>
                                <NormalTable
                                  tableId={`regionalLevelSales-${level}`}
                                  data={regionalLevelSalesState}
                                  selectedIds={selectedIds}
                                  onSelectionChange={handleSelectionChange}
                                  prioritizeSelected={isButtonDisabled}
                                  onCategoryClick={handleCategoryClick}
                                  onParentProductClick={handleParentProductClick}
                                  loading={loadingState?.regionalLevelSalesState}
                                  sequence={regionalLevelSalesSequence}
                                  downloadBtnPermission={downloadBtnPermission}
                                  isProductwiseTable={viewType === 'product' || viewType === 'variation'}
                                  onColumnChange={handleColumnChange}
                                  showSelectColumn={true}
                                  section={"regional_sales"}
                                />
                              </PermissionControlledCard>
                            )
                          )}
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>}

      {/* Floating Button for Apply Selection */}
      {(selectedIds.productId.length + selectedIds.categoryId.length > 0) && (
        <button
          className="floating-btn-select"
          onClick={handleReflectSelection}
          disabled={isButtonDisabled}
        >
          ({selectedIds.productId.length + selectedIds.categoryId.length}) {t("checkboxSelect.heading")}
        </button>
      )}
    </>
  );
};

export default RegionalLevelSales;
